export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      vehicles: "Nos véhicules",
      services: "Services",
      destinations: "Destinations",
      prices: "Tarifs",
      about: "À propos",
      contact: "Contact",
    },
    actions: {
      book: "Réserver",
      bookTrip: "Réserver mon trajet",
      bookNow: "Réserver maintenant",
      discover: "Découvrir",
      discoverAll: "Toutes nos destinations",
    },
    header: {
      phone: "Appeler CAB CITY",
      openMenu: "Ouvrir le menu",
      closeMenu: "Fermer le menu",
      skipContent: "Aller au contenu",
    },
    language: {
      french: "Français",
      english: "English",
      switchToFrench: "Passer le site en français",
      switchToEnglish: "Passer le site en anglais",
    },
    common: {
      book: "Réserver mon trajet",
      call: "Appeler CAB CITY",
      discover: "Découvrir",
    },
    home: {
      seoTitle: "Taxi Paris | Réservez votre taxi avec chauffeur – CAB CITY",
      seoDescription:
        "Taxi à Paris et en Île-de-France : réservation en ligne, chauffeur professionnel, transferts CDG, Orly, gares et Disneyland Paris. Jusqu'à 8 passagers.",
      badge: "Taxi Van · Paris & Île-de-France",
      title: "Taxi Van à Paris jusqu'à 8 passagers",
      intro: "Déplacements privés, transferts aéroports, gares et Disneyland Paris. Voyagez confortablement avec un chauffeur professionnel et un van spacieux.",
      heroIntro: "Réservez votre taxi à Paris avec chauffeur professionnel pour vos déplacements à Paris, vers les aéroports, les gares et Disneyland Paris, jusqu'à 8 passagers.",
      servicesEyebrow: "Nos services",
      servicesTitle: "Un transport privé pour chaque trajet",
      servicesText: "Transferts vers les aéroports CDG et Orly, les gares parisiennes, Disneyland Paris ou toute autre destination en Île-de-France.",
      vehicleEyebrow: "Notre véhicule",
      vehicleTitle: "Mercedes Classe V : confort et espace",
      airportsEyebrow: "Transferts aéroports",
      airportsTitle: "CDG & Orly, en toute sérénité",
      disneyEyebrow: "Destination famille",
      disneyTitle: "Paris ↔ Disneyland Paris",
      stationsEyebrow: "Transferts gares",
      stationsTitle: "Toutes les gares de Paris, sans stress",
      stationsLink: "Transferts gares de Paris",
      whyEyebrow: "Pourquoi CAB CITY",
      whyTitle: "La différence CAB CITY",
      destinationsEyebrow: "Destinations",
      destinationsTitle: "Où souhaitez-vous aller ?",
      destinationsLink: "Toutes nos destinations",
      faqEyebrow: "Questions fréquentes",
      faqTitle: "Vos questions, nos réponses",
      finalTitle: "Besoin d'un taxi van à Paris ?",
      finalText: "Voyagez confortablement jusqu'à 8 passagers avec CAB CITY.",
      heroBook: "Réserver mon trajet",
      vehicleDiscover: "Découvrir nos véhicules",
      driverDiscover: "Découvrir le chauffeur privé",
      stationTransfers: "Transferts gares de Paris",
      allDestinations: "Toutes nos destinations",
      bookNow: "Réserver maintenant",
      learnMore: "En savoir plus",
    },
  },

  en: {
    nav: {
      home: "Home",
      vehicles: "Our Vehicles",
      services: "Services",
      destinations: "Destinations",
      prices: "Prices",
      about: "About",
      contact: "Contact",
    },
    actions: {
      book: "Book",
      bookTrip: "Book my ride",
      bookNow: "Book now",
      discover: "Discover",
      discoverAll: "All destinations",
    },
    header: {
      phone: "Call CAB CITY",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      skipContent: "Skip to content",
    },
    language: {
      french: "Français",
      english: "English",
      switchToFrench: "Switch website to French",
      switchToEnglish: "Switch website to English",
    },
    common: {
      book: "Book my ride",
      call: "Call CAB CITY",
      discover: "Discover",
    },
    home: {
      seoTitle: "Taxi Paris | Book a Private Taxi with Driver – CAB CITY",
      seoDescription:
        "Taxi service in Paris and Île-de-France: online booking, professional driver, CDG, Orly, train stations and Disneyland Paris transfers. Up to 8 passengers.",
      badge: "Taxi Van · Paris & Île-de-France",
      title: "Taxi Van in Paris for up to 8 passengers",
      intro: "Private transportation, airport transfers, train stations and Disneyland Paris. Travel comfortably with a professional driver and a spacious van.",
      servicesEyebrow: "Our services",
      servicesTitle: "Private transportation for every journey",
      servicesText: "Transfers to CDG and Orly airports, Paris train stations, Disneyland Paris or any other destination in Île-de-France.",
      vehicleEyebrow: "Our vehicle",
      vehicleTitle: "Mercedes V-Class: comfort and space",
      airportsEyebrow: "Airport transfers",
      airportsTitle: "CDG & Orly, with complete peace of mind",
      disneyEyebrow: "Family destination",
      disneyTitle: "Paris ↔ Disneyland Paris",
      stationsEyebrow: "Train station transfers",
      stationsTitle: "All Paris train stations, stress-free",
      stationsLink: "Paris train station transfers",
      whyEyebrow: "Why CAB CITY",
      whyTitle: "The CAB CITY difference",
      destinationsEyebrow: "Destinations",
      destinationsTitle: "Where would you like to go?",
      destinationsLink: "All destinations",
      faqEyebrow: "Frequently asked questions",
      faqTitle: "Your questions, our answers",
      finalTitle: "Need a taxi van in Paris?",
      finalText: "Travel comfortably with up to 8 passengers with CAB CITY.",
      scroll: "Scroll",
      heroTitle1: "Taxi Van in Paris",
      heroTitle2: "up to 8 passengers",
      heroIntro: "Travel comfortably with up to 8 passengers and a professional driver for transfers in Paris, airports, train stations and Disneyland Paris.",
      call: "Call CAB CITY",
      bullet1: "Up to 8 passengers",
      bullet2: "Spacious and comfortable vehicles",
      bullet3: "Professional driver",
      bullet4: "Airports, train stations and Disneyland Paris",
      versailles: "transfer to Versailles",
      servicesText: "Transfers to CDG and Orly airports, Paris train stations, Disneyland Paris or any other destination in Île-de-France.",
      vehicleEyebrow: "Our signature vehicle",
      vehicleTitle: "Travel comfortably in a Mercedes V-Class",
      vehicleText: "A spacious premium van designed for families, groups and business travel, with room for up to 8 passengers and their luggage.",
      vehicleButton: "Discover our vehicles",
      airportsTitle: "Your airport taxi in Paris, with complete peace of mind",
      airportCdgText: "Your CAB CITY taxi picks you up at home, your hotel or office and takes you directly to the right terminal. For arrivals, your driver is waiting for a smooth CDG–Paris transfer.",
      airportOrlyText: "For departures from or arrivals at Orly, book your taxi van for up to 8 passengers and their luggage in one comfortable Orly–Paris transfer.",
      bookCdg: "Book a CDG taxi",
      bookOrly: "Book an Orly taxi",
      disneyEyebrow: "Family destination",
      disneyTitle: "Taxi Van Paris – Disneyland Paris",
      disneyText: "Travel comfortably with your family between Paris, the airports and Disneyland Paris. Our spacious vans are ideal for children, strollers and luggage.",
      disneyButton: "Discover Disneyland Paris",
      disneyBook: "Book my Disneyland transfer",
      stationsEyebrow: "Train station transfers",
      stationsTitle: "All Paris train stations, stress-free",
      stationsText: "Gare de Lyon, Montparnasse, Gare du Nord, Gare de l'Est, Saint-Lazare, Austerlitz and Bercy: travel comfortably to or from any major Paris station.",
      stationsButton: "Paris train station transfers",
      chauffeurEyebrow: "Tailored service",
      chauffeurTitle: "Private chauffeur in Paris",
      chauffeurText: "Business trips, events, appointments, sightseeing or private transfers: enjoy a professional chauffeur and premium van at your service.",
      chauffeurButton: "Discover our private chauffeur",
      business: "Business travel",
      events: "Events & evenings",
      sightseeing: "Sightseeing",
      appointments: "Private appointments",
      availability: "On-demand service",
      heroBook: "Book my ride",
      vehicleDiscover: "Discover our vehicles",
      driverDiscover: "Discover our private chauffeur",
      stationTransfers: "Paris train station transfers",
      allDestinations: "All destinations",
      bookNow: "Book now",
      learnMore: "Learn more",
    },
  },
};

export function translate(language, path) {
  const parts = path.split(".");
  let value = translations[language];

  for (const part of parts) {
    value = value?.[part];
    if (value === undefined) return path;
  }

  return value;
}
